import styled from 'styled-components';

export const TopBarWrapper = styled.div`
  padding: 43px 0 0;
  background-color: ${({ theme }) => theme.titleBarBackgroundColor};
  margin-bottom: 32px;
  min-height: 159px;
  display: flex;
  flex-direction: column;
  gap: 44px;
  position: sticky;
  top: 0;
  z-index: 15;
`;

export const FirstRow = styled.div`
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const SecondRow = styled.div`
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.secondRowBorderColor};
  border-bottom: 1px solid ${({ theme }) => theme.secondRowBorderColor};
`;
